<script setup lang="ts">
  import { default as WriteAlarm } from "./WriteAlarm.vue";
  import { default as WriteAlarmSuccess } from "./WriteAlarmSuccess.vue";
  import { default as WriteAlarmError } from "./WriteAlarmError.vue";

  const { step } = defineProps<{ step: string }>();
  const emit = defineEmits<{ (e: "click:more"): void; (e: "click:cancel"): void }>();
</script>

<template>
  <WriteAlarm v-if="step === 'start'" @click:cancel="emit('click:cancel')" />
  <WriteAlarmSuccess v-if="step === 'success'" @click:more="emit('click:more')" @click:cancel="emit('click:cancel')" />
  <WriteAlarmError v-if="step === 'error'" />
</template>
